/* ================================================== */
/* SCROLL TO
/* ================================================== */

function scrollTo(element) {
	var offset = $(element).offset().top,
		duration = Math.abs((offset - $(window).scrollTop()) / 5),
		duration = (duration < 250) ? 250 : duration,
		duration = (duration > 800) ? 800 : duration;

	$('html, body').animate({
		scrollTop: offset
	}, duration, 'swing');
}